exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".list-group-item[data-v-76e19afc]{padding:.25rem 0;border:0}", ""]);

// exports
